import React from 'react'

type Props = {
	type: string
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const icons = require('@ant-design/icons')

const DynamicIcon = (props: Props) => {
	const { type } = props
	const Component = icons[type]
	return <Component />
}

export default DynamicIcon
